import {
  LOAD_SINGLE_POST,
  LOAD_SINGLE_POST_REF,
  LOAD_SINGLE_POST_DATA,
  MERGE_SINGLE_POST,
  MERGE_SINGLE_POST_DATA,
  SAVE_SINGLE_POST_REF,
  SAVE_SINGLE_POST_DATA,
  EXIST_PUBLICATION_SINGLE_POST,
  RESET_SINGLE_POST_ACTION,
  RESET_SINGLE_POST
} from '../actions/singlePostQueries'
import { _ } from 'vue-underscore'
import firebase from 'firebase'
// import * as Sentry from '@sentry/vue'
import { postsDB, userDB } from '../../firestoreDB'
import { docToPostRef, docToPostData } from '@/converters/postConverter'

const getDefaultState = () => ({
  singlePostData: {},
  singlePostRef: {}
})

const state = getDefaultState()

const getters = {
  getSinglePostData: state => state.singlePostData,
  getSinglePostRef: state => state.singlePostRef
}

const actions = {
  [LOAD_SINGLE_POST_REF]: ({ commit, getters, dispatch }, key) => {
    return new Promise((resolve, reject) => {
      userDB
        .doc(getters.firebaseUUID())
        .collection('publications')
        .where(firebase.firestore.FieldPath.documentId(), '==', key)
        .onSnapshot({ includeMetadataChanges: true }, snapshotDoc => {
          snapshotDoc.docChanges().forEach(docChanged => {
            const doc = docChanged.doc
            const postRef = docToPostRef(doc)
            commit(SAVE_SINGLE_POST_REF, postRef)
            resolve(postRef)
          })
        })
    })
  },
  [LOAD_SINGLE_POST_DATA]: ({ commit, getters, dispatch }, key) => {
    return new Promise(resolve => {
      postsDB
        .where(firebase.firestore.FieldPath.documentId(), '==', key)
        .onSnapshot({ includeMetadataChanges: true }, snapshotDoc => {
          snapshotDoc.docChanges().forEach(docChanged => {
            const doc = docChanged.doc
            const postData = docToPostData(doc, {})
            commit(SAVE_SINGLE_POST_DATA, postData)
            resolve(postData)
          })
        })
    })
  },
  [LOAD_SINGLE_POST]: ({ dispatch }, keyPost) => {
    return new Promise((resolve, reject) => {
      Promise.all([
        dispatch(LOAD_SINGLE_POST_REF, keyPost),
        dispatch(LOAD_SINGLE_POST_DATA, keyPost)
      ])
        .then(() => {
          resolve(true)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [MERGE_SINGLE_POST]: ({ commit }, value) => {
    commit(MERGE_SINGLE_POST_DATA, value)
  },
  [EXIST_PUBLICATION_SINGLE_POST]: ({ getters }, key) => {
    return new Promise(resolve => {
      userDB
        .doc(getters.firebaseUUID())
        .collection('publications')
        .doc(key)
        .get()
        .then(doc => doc.exists ? resolve(true) : resolve(false))
    })
  },
  [RESET_SINGLE_POST_ACTION]: ({ commit }) => {
    commit(RESET_SINGLE_POST)
  }
}
const mutations = {
  [SAVE_SINGLE_POST_REF]: (state, postRef) => {
    state.singlePostRef = postRef
  },
  [SAVE_SINGLE_POST_DATA]: (state, postData) => {
    state.singlePostData = postData
  },
  [MERGE_SINGLE_POST_DATA]: (state, value) => {
    const { data } = value
    if (!_.isEmpty(data)) {
      state.singlePostData = { ...state.singlePostData, ...data }
    }
  },
  [RESET_SINGLE_POST]: state => {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/singlePostQuery.js